// THIS IS THE DEFAULT VALUE YOU CAN CHANGE IF YOU WANT

const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 1200,
    lg: 1440,
    xl: 1920,
  },
};

export default breakpoints;
